import moment from 'moment';
import React from 'react';
import { numberToCurrency } from 'utils/misc';
import { roundToTwoDecimals } from 'utils/numbers';
import { List as ListLoader } from 'react-content-loader';
import { InfoWidget } from '@ds/react-components';
import InfoWidgetTextRow from '../common/InfoWidgetTextRow';

const AccountDetails = (props) => {
  const { accountDetails, localisation } = props;
  const { dateFormat } = localisation.locales;
  const {
    balanceToSettle,
    startDate,
    finishDate,
    numOfTerm,
    termType,
    billNext,
  } = accountDetails;

  const loaderStyle = {
    height: '150',
    width: '100%',
  };
  return (
    <InfoWidget
      title="Account Details"
      collapsible={true}
      isOpen={true}
      isLoading={billNext === undefined || termType === undefined}
      contentLoader={<ListLoader style={loaderStyle} />}>
      <InfoWidgetTextRow
        title={'Balance to Settle'}
        value={numberToCurrency(
          roundToTwoDecimals(balanceToSettle),
          localisation
        )}
      />
      <InfoWidgetTextRow
        title={'Start Date'}
        value={startDate && moment(startDate).format(dateFormat)}
      />
      <InfoWidgetTextRow
        title={'Finish Date'}
        value={finishDate ? moment(finishDate).format(dateFormat) : 'Ongoing'}
      />
      <InfoWidgetTextRow
        title={'Minimum Term'}
        value={`${numOfTerm} ${localisation.prompts.termType[termType]}`}
      />
      <InfoWidgetTextRow
        title={'Next Payment Date'}
        value={billNext && moment(billNext).format(dateFormat)}
      />
    </InfoWidget>
  );
};

export default AccountDetails;
